import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';

@Component({
    selector: 'ap-sales-channel-dialog',
    templateUrl: 'sales-channel.dialog.html',
    styleUrls: ['./sales-channel.dialog.scss']
})
export class SalesChannelDialog {

    public channel: string;
    public item: InventoryItem;
    public defaults: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SalesChannelDialog>,
        public dialog: MatDialog
    ) {
        this.item = data.item;
        this.defaults = data.salesChannel.defaults;
        this.channel = data.salesChannel.type;
    }

}
